<router-outlet />
<app-light-switch></app-light-switch>
